import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eb5c8d48")

_pushScopeId("data-v-eb5c8d48")
const _hoisted_1 = { id: "rectEditor" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Border-radius", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dimensions", -1)
const _hoisted_6 = { class: "settings-row" }
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_9 = { class: "input-box" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "W", -1)
const _hoisted_11 = { class: "settings-row" }
const _hoisted_12 = { class: "input-box" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_14 = { class: "input-box" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "H", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_color_input = _resolveComponent("color-input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_color_input, {
      color: _ctx.component.color,
      "onUpdate:color": _cache[1] || (_cache[1] = $event => (_ctx.component.color = $event))
    }, null, 8, ["color"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "number",
        onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
        style: {"width":"48px"},
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.component.radius = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.component.radius,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[3] || (_cache[3] = $event => (_ctx.inputTransformer($event, _ctx.component.x))),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.component.x = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_8
      ]),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[5] || (_cache[5] = $event => (_ctx.inputTransformer($event, _ctx.component.width))),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.component.width = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.width,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_10
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[7] || (_cache[7] = $event => (_ctx.inputTransformer($event, _ctx.component.y))),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.component.y = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_13
      ]),
      _createVNode("div", _hoisted_14, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[9] || (_cache[9] = $event => (_ctx.inputTransformer($event, _ctx.component.height))),
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.component.height = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.component.height,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_15
      ])
    ])
  ]))
})